module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-3-svgrepo-com.219e26ce.svg";